import { render, staticRenderFns } from "./StoreCorporation.vue?vue&type=template&id=1b72289c&scoped=true&"
import script from "./StoreCorporation.vue?vue&type=script&lang=js&"
export * from "./StoreCorporation.vue?vue&type=script&lang=js&"
import style0 from "./StoreCorporation.vue?vue&type=style&index=0&id=1b72289c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72289c",
  null
  
)

export default component.exports